export const SERVER_ADDRESS = process.env.FRONTEND_SERVER_ADDRESS || '';

export const HOST_ADDRESS_LIST = {
  PROFILE_SERVER: `${SERVER_ADDRESS}/profile_api`,
  CRS_SERVER: `${SERVER_ADDRESS}/crs_api`,
  BUSINESS_PROFILE_SERVER: `${SERVER_ADDRESS}/business_api`,
  NODE_SERVER: `${SERVER_ADDRESS}/api`,
  REPORTS_SERVER: `${SERVER_ADDRESS}/reports_api`
};

export const HOST_ADDRESS = HOST_ADDRESS_LIST.CRS_SERVER;

export const CO_OYO_BFF = 'https://partner-app.oyorooms.com';
export const HMS_BFF = 'https://api.oyoos.com';
